import { ZH_ACCOUNT } from './zh/account';
import { ZH_COURSE_INTRO_A } from './zh/courseIntroA';
import { ZH_COURSE_INTRO_B } from './zh/courseIntroB';
import { ZH_COURSES } from './zh/courses';
import { ZH_FAMILY } from './zh/family';
import { ZH_PATHWAY } from './zh/pathway';
import { ZH_SHARED } from './zh/shared';
import { ZH_SHELL } from './zh/shell';
import { ZH_STUDY } from './zh/study';

/**
 * Chinese (Simplified) display text for the Parent Portal.
 *
 * Key = the exact English source string in code. One file per area so parallel
 * work never collides. The same key may appear in two files only with the same
 * Chinese text (portalZh.test.ts enforces this). Keep `{name}` placeholders
 * identical in both languages. Product names (Hangar, HSC, Airbotix) stay in
 * English. Course content is English-only and never goes in this catalogue
 * (rules/course-content-english-only.md).
 */
export const PORTAL_ZH_PARTS: Readonly<Record<string, Readonly<Record<string, string>>>> = {
  shell: ZH_SHELL,
  account: ZH_ACCOUNT,
  family: ZH_FAMILY,
  courses: ZH_COURSES,
  study: ZH_STUDY,
  pathway: ZH_PATHWAY,
  shared: ZH_SHARED,
  courseIntroA: ZH_COURSE_INTRO_A,
  courseIntroB: ZH_COURSE_INTRO_B,
};

export const PORTAL_ZH: Readonly<Record<string, string>> = Object.assign(
  {},
  ...Object.values(PORTAL_ZH_PARTS),
);
